import {
  DREAM_SPECIAL_EVENT_ID,
  DREAM_USER_EMAIL,
  getSviObjectEventId,
  parseSviObjectEventId,
} from "../constants/dream.constants";
import { IEvent } from "../interfaces/map.interfaces";
import { ISviStatisticRow, ISviStatisticSummary } from "../interfaces/services.interfaces";

export const sviStatisticSummary: ISviStatisticSummary = {
  averageProgressPercent: "7%",
  objectsWithVisibleProgress: 1482,
  noProgressObjects: 58,
  lastImageCaptureDate: "19.06.2026",
};

export const sviStatisticRows: ISviStatisticRow[] = [
  {
    objectId: "0001",
    name: "Residential Block, Newton str. 19, Zaporizhzhia",
    isPrimary: true,
    y2021: "-",
    y2022: "Start E18",
    y2023: "E35",
    y2024: "E70",
    q2021_1: "-",
    q2021_2: "-",
    q2021_3: "-",
    q2021_4: "-",
    q2022_1: "E5",
    q2022_2: "E10",
    q2022_3: "E15",
    q2022_4: "E18",
    q2023_1: "E20",
    q2023_2: "E25",
    q2023_3: "E27",
    q2023_4: "E35",
    q2024_1: "E45",
    q2024_2: "E55",
    q2024_3: "E60",
    q2024_4: "E70",
    q2025_1: "E75",
    q2025_2: "E75 Alert",
    q2025_3: "E80",
    q2025_4: "E85",
    noProgress: "-",
  },
  {
    objectId: "0002",
    name: "Major repairs of Irpin Lyceum No. 3",
    y2021: "-",
    y2022: "E25",
    y2023: "E95",
    y2024: "E100",
    q2021_1: "-",
    q2021_2: "-",
    q2021_3: "-",
    q2021_4: "-",
    q2022_1: "E0",
    q2022_2: "E0",
    q2022_3: "E10",
    q2022_4: "E25",
    q2023_1: "E40",
    q2023_2: "E55",
    q2023_3: "E80",
    q2023_4: "E95",
    q2024_1: "E100",
    q2024_2: "E100",
    q2024_3: "E100",
    q2024_4: "E100",
    q2025_1: "E100",
    q2025_2: "E100",
    q2025_3: "E100",
    q2025_4: "E100",
    noProgress: "-",
  },
  {
    objectId: "0003",
    name: "Reconstruction of the airport terminal, Vinnytsia Airport",
    y2021: "-",
    y2022: "E0",
    y2023: "E0",
    y2024: "E0",
    q2021_1: "-",
    q2021_2: "-",
    q2021_3: "-",
    q2021_4: "-",
    q2022_1: "E0",
    q2022_2: "E0",
    q2022_3: "E0",
    q2022_4: "E0",
    q2023_1: "E0",
    q2023_2: "E0",
    q2023_3: "E0",
    q2023_4: "E0",
    q2024_1: "E0",
    q2024_2: "E0",
    q2024_3: "E0",
    q2024_4: "E0",
    q2025_1: "E0",
    q2025_2: "E0",
    q2025_3: "E0",
    q2025_4: "E0",
    noProgress: "ALERT",
  },
  {
    objectId: "0004",
    name: "Arrangement of a shelter on the basis of Chernihiv school of grades I-III No. 19",
    y2021: "-",
    y2022: "E0",
    y2023: "E0",
    y2024: "E100",
    q2021_1: "-",
    q2021_2: "-",
    q2021_3: "-",
    q2021_4: "-",
    q2022_1: "E0",
    q2022_2: "E0",
    q2022_3: "E0",
    q2022_4: "E0",
    q2023_1: "E0",
    q2023_2: "E0",
    q2023_3: "E0",
    q2023_4: "E0",
    q2024_1: "E20",
    q2024_2: "E50",
    q2024_3: "E75",
    q2024_4: "E100",
    q2025_1: "E100",
    q2025_2: "E100",
    q2025_3: "E100",
    q2025_4: "E100",
    noProgress: "-",
  },
  {
    objectId: "0005",
    name: "Restoration of a building of local architectural significance, Chernihiv",
    y2021: "-",
    y2022: "E0",
    y2023: "E0",
    y2024: "E60",
    q2021_1: "-",
    q2021_2: "-",
    q2021_3: "-",
    q2021_4: "-",
    q2022_1: "E0",
    q2022_2: "E0",
    q2022_3: "E0",
    q2022_4: "E0",
    q2023_1: "E0",
    q2023_2: "E0",
    q2023_3: "E0",
    q2023_4: "E0",
    q2024_1: "E30",
    q2024_2: "E40",
    q2024_3: "E50",
    q2024_4: "E60",
    q2025_1: "E65",
    q2025_2: "E70",
    q2025_3: "E80",
    q2025_4: "E90",
    noProgress: "-",
  },
];

/** Metadata shown on the object statistics page (no dashboard flag here). */
export interface IObjectDetails {
  state: string;
  type: string;
  dateOfStart: string;
  dateEnd: string;
  currentFulfillment: string;
  contractor: string;
  lastUpdated: string;
  location: string;
}

export interface IObjectQuarterData {
  number: number;
  prevQuarterPercent: string;
  startOfYearPercent: string | null;
  buttonText: string;
  hasAlert?: boolean;
}

export type DashboardYearKey = 2021 | 2022 | 2023 | 2024 | 2025;

export interface IObjectDashboardConfig {
  objectId: string;
  headerTitle: string;
  details: IObjectDetails;
  hasDashboard: boolean;
  /** Years omitted → dashboard shows blank quarter tiles for that year. */
  quartersByYear: Partial<Record<DashboardYearKey, IObjectQuarterData[]>>;
}

/** Quarter row data when a year has no configured data (e.g. object 0003 before 2024). */
export const BLANK_YEAR_QUARTERS: IObjectQuarterData[] = [
  { number: 1, prevQuarterPercent: "-", startOfYearPercent: null, buttonText: "-" },
  { number: 2, prevQuarterPercent: "-", startOfYearPercent: "-", buttonText: "-" },
  { number: 3, prevQuarterPercent: "-", startOfYearPercent: "-", buttonText: "-" },
  { number: 4, prevQuarterPercent: "-", startOfYearPercent: "-", buttonText: "-" },
];

const quarters0001ByYear: IObjectDashboardConfig["quartersByYear"] = {
  2025: [
    { number: 1, prevQuarterPercent: "10%", startOfYearPercent: null, buttonText: "E75" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "10%", buttonText: "E75", hasAlert: true },
    { number: 3, prevQuarterPercent: "15%", startOfYearPercent: "15%", buttonText: "E80" },
    { number: 4, prevQuarterPercent: "10%", startOfYearPercent: "20%", buttonText: "E85" },
  ],
  2024: [
    { number: 1, prevQuarterPercent: "15%", startOfYearPercent: null, buttonText: "E45" },
    { number: 2, prevQuarterPercent: "15%", startOfYearPercent: "15%", buttonText: "E55" },
    { number: 3, prevQuarterPercent: "10%", startOfYearPercent: "20%", buttonText: "E60" },
    { number: 4, prevQuarterPercent: "20%", startOfYearPercent: "30%", buttonText: "E70" },
  ],
  2023: [
    { number: 1, prevQuarterPercent: "10%", startOfYearPercent: null, buttonText: "E20" },
    { number: 2, prevQuarterPercent: "20%", startOfYearPercent: "20%", buttonText: "E25" },
    { number: 3, prevQuarterPercent: "10%", startOfYearPercent: "30%", buttonText: "E27" },
    { number: 4, prevQuarterPercent: "25%", startOfYearPercent: "45%", buttonText: "E35" },
  ],
  2022: [
    { number: 1, prevQuarterPercent: "10%", startOfYearPercent: null, buttonText: "E5" },
    { number: 2, prevQuarterPercent: "25%", startOfYearPercent: "25%", buttonText: "E10" },
    { number: 3, prevQuarterPercent: "20%", startOfYearPercent: "40%", buttonText: "E15" },
    { number: 4, prevQuarterPercent: "5%", startOfYearPercent: "50%", buttonText: "E18" },
  ],
  2021: BLANK_YEAR_QUARTERS,
};

const E0_YEAR_QUARTERS: IObjectQuarterData[] = [
  { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
  { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
];

const quarters0003ByYear: IObjectDashboardConfig["quartersByYear"] = {
  2022: E0_YEAR_QUARTERS,
  2023: E0_YEAR_QUARTERS,
  2024: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    {
      number: 2,
      prevQuarterPercent: "0%",
      startOfYearPercent: "0%",
      buttonText: "E0",
      hasAlert: true,
    },
    {
      number: 3,
      prevQuarterPercent: "0%",
      startOfYearPercent: "0%",
      buttonText: "E0",
      hasAlert: true,
    },
    {
      number: 4,
      prevQuarterPercent: "0%",
      startOfYearPercent: "0%",
      buttonText: "E0",
      hasAlert: true,
    },
  ],
  2025: E0_YEAR_QUARTERS,
};

const quarters0002ByYear: IObjectDashboardConfig["quartersByYear"] = {
  2021: BLANK_YEAR_QUARTERS,
  2022: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 3, prevQuarterPercent: "10%", startOfYearPercent: "0%", buttonText: "E10" },
    { number: 4, prevQuarterPercent: "15%", startOfYearPercent: "10%", buttonText: "E25" },
  ],
  2023: [
    { number: 1, prevQuarterPercent: "15%", startOfYearPercent: null, buttonText: "E40" },
    { number: 2, prevQuarterPercent: "15%", startOfYearPercent: "15%", buttonText: "E55" },
    { number: 3, prevQuarterPercent: "25%", startOfYearPercent: "30%", buttonText: "E80" },
    { number: 4, prevQuarterPercent: "15%", startOfYearPercent: "55%", buttonText: "E95" },
  ],
  2024: [
    { number: 1, prevQuarterPercent: "5%", startOfYearPercent: null, buttonText: "E100" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "5%", buttonText: "E100" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "5%", buttonText: "E100" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "5%", buttonText: "E100" },
  ],
  2025: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E100" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
  ],
};

const quarters0004ByYear: IObjectDashboardConfig["quartersByYear"] = {
  2021: BLANK_YEAR_QUARTERS,
  2022: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  ],
  2023: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  ],
  2024: [
    { number: 1, prevQuarterPercent: "20%", startOfYearPercent: null, buttonText: "E20" },
    { number: 2, prevQuarterPercent: "30%", startOfYearPercent: "20%", buttonText: "E50" },
    { number: 3, prevQuarterPercent: "25%", startOfYearPercent: "50%", buttonText: "E75" },
    { number: 4, prevQuarterPercent: "25%", startOfYearPercent: "75%", buttonText: "E100" },
  ],
  2025: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E100" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E100" },
  ],
};

const quarters0005ByYear: IObjectDashboardConfig["quartersByYear"] = {
  2021: BLANK_YEAR_QUARTERS,
  2022: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  ],
  2023: [
    { number: 1, prevQuarterPercent: "0%", startOfYearPercent: null, buttonText: "E0" },
    { number: 2, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 3, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
    { number: 4, prevQuarterPercent: "0%", startOfYearPercent: "0%", buttonText: "E0" },
  ],
  2024: [
    { number: 1, prevQuarterPercent: "30%", startOfYearPercent: null, buttonText: "E30" },
    { number: 2, prevQuarterPercent: "10%", startOfYearPercent: "30%", buttonText: "E40" },
    { number: 3, prevQuarterPercent: "10%", startOfYearPercent: "40%", buttonText: "E50" },
    { number: 4, prevQuarterPercent: "10%", startOfYearPercent: "50%", buttonText: "E60" },
  ],
  2025: [
    { number: 1, prevQuarterPercent: "5%", startOfYearPercent: null, buttonText: "E65" },
    { number: 2, prevQuarterPercent: "5%", startOfYearPercent: "5%", buttonText: "E70" },
    { number: 3, prevQuarterPercent: "10%", startOfYearPercent: "10%", buttonText: "E80" },
    { number: 4, prevQuarterPercent: "10%", startOfYearPercent: "20%", buttonText: "E90" },
  ],
};

/**
 * Per-object dashboard + object-statistics metadata.
 * Add a new key here to support another object end-to-end.
 */
export const objectConfigs: Record<string, IObjectDashboardConfig> = {
  "0001": {
    objectId: "0001",
    headerTitle: "OBJECT: 0001 Residential Block, Newton str. 19, Zaporizhzhia",
    details: {
      state: "active",
      type: "residential",
      dateOfStart: "01.01.2022",
      dateEnd: "01.01.2027",
      currentFulfillment: "85%",
      contractor: "ABC company",
      lastUpdated: "30.03.2026",
      location: "35.10536, 47.83712",
    },
    hasDashboard: true,
    quartersByYear: quarters0001ByYear,
  },
  "0002": {
    objectId: "0002",
    headerTitle:
      "OBJECT: 0002 Major repairs of Irpin Lyceum No. 3",
    details: {
      state: "done",
      type: "Education. General secondary education.",
      dateOfStart: "02.04.2022",
      dateEnd: "June 2024",
      currentFulfillment: "100",
      contractor: "N/A",
      lastUpdated: "19.03.2026",
      location: "30.25827, 50.53670",
    },
    hasDashboard: true,
    quartersByYear: quarters0002ByYear,
  },
  "0003": {
    objectId: "0003",
    headerTitle:
      "OBJECT: 0003 Reconstruction of the airport terminal, Vinnytsia Airport",
    details: {
      state: "active",
      type: "Transport. Aviation.",
      dateOfStart: "01.06.2024",
      dateEnd: "N/A",
      currentFulfillment: "0",
      contractor: 'Private enterprise "B.V.V.-BUD"',
      lastUpdated: "19.03.2026",
      location: "28.59808, 49.22794",
    },
    hasDashboard: true,
    quartersByYear: quarters0003ByYear,
  },
  "0004": {
    objectId: "0004",
    headerTitle:
      "OBJECT: 0004 Arrangement of a shelter on the basis of Chernihiv school of grades I-III No. 19",
    details: {
      state: "done",
      type: "Education. General secondary education.",
      dateOfStart: "01.03.2024",
      dateEnd: "01.12.2024",
      currentFulfillment: "100",
      contractor: "N/A",
      lastUpdated: "19.03.2026",
      location: "31.28776, 51.50303",
    },
    hasDashboard: true,
    quartersByYear: quarters0004ByYear,
  },
  "0005": {
    objectId: "0005",
    headerTitle:
      "OBJECT: 0005 Restoration of a building of local architectural significance, Chernihiv",
    details: {
      state: "active",
      type: "Other sectors. Culture.",
      dateOfStart: "01.04.2024",
      dateEnd: "01.04.2026",
      currentFulfillment: "100",
      contractor: "N/A",
      lastUpdated: "01.06.2026",
      location: "31.29761, 51.49065",
    },
    hasDashboard: true,
    quartersByYear: quarters0005ByYear,
  },
};

function parseLocationCoordinates(location: string): [number, number] | null {
  const parts = location.split(",").map((part) => parseFloat(part.trim()));
  if (parts.length !== 2 || parts.some((value) => Number.isNaN(value))) {
    return null;
  }
  return [parts[0], parts[1]];
}

function mapEventTypeFromDetails(type: string): string {
  const normalized = type.trim().toLowerCase();
  if (normalized.startsWith("residential")) {
    return "residential";
  }
  if (normalized.startsWith("education")) {
    return "education";
  }
  if (normalized.startsWith("transport")) {
    return "transport";
  }
  return "other";
}

function formatFulfillmentPercent(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }
  return trimmed.endsWith("%") ? trimmed : `${trimmed}%`;
}

function lastUpdatedToIsoDate(lastUpdated: string): string {
  const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(lastUpdated.trim());
  if (!match) {
    return "2026-06-19T00:00:00Z";
  }
  const [, day, month, year] = match;
  return `${year}-${month}-${day}T00:00:00Z`;
}

/** Minimum separation so nearby object markers remain visible when zoomed out. */
const MARKER_MIN_SEPARATION_DEG = 0.025;

export function spreadSviObjectMapEventCoordinates(events: IEvent[]): IEvent[] {
  const placed: [number, number][] = [];

  return events.map((event) => {
    const [baseLon, baseLat] = event.coordinates;
    let lon = baseLon;
    let lat = baseLat;
    let collisionIndex = 0;

    const collides = (testLon: number, testLat: number) =>
      placed.some(([placedLon, placedLat]) => {
        const dLon = testLon - placedLon;
        const dLat = testLat - placedLat;
        return Math.hypot(dLon, dLat) < MARKER_MIN_SEPARATION_DEG;
      });

    while (collides(lon, lat)) {
      collisionIndex += 1;
      const angle = (collisionIndex * 72 * Math.PI) / 180;
      lon = baseLon + MARKER_MIN_SEPARATION_DEG * collisionIndex * 0.4 * Math.cos(angle);
      lat = baseLat + MARKER_MIN_SEPARATION_DEG * collisionIndex * 0.4 * Math.sin(angle);
    }

    placed.push([lon, lat]);

    if (lon === baseLon && lat === baseLat) {
      return event;
    }

    return {
      ...event,
      coordinates: [lon, lat],
    };
  });
}

export function buildSviObjectMapEvent(objectId: string): IEvent | null {
  const cfg = objectConfigs[objectId];
  if (!cfg?.hasDashboard || !cfg.details.location) {
    return null;
  }

  const coordinates = parseLocationCoordinates(cfg.details.location);
  if (!coordinates) {
    return null;
  }

  const row = sviStatisticRows.find((entry) => entry.objectId === objectId);
  const eventType = mapEventTypeFromDetails(cfg.details.type);

  return {
    type: "Point",
    coordinates,
    properties: {
      id: getSviObjectEventId(objectId),
      locationId: `svi_location_${objectId}`,
      state: cfg.details.state || "active",
      type: eventType,
      sourcetype: eventType,
      subType: "",
      author: DREAM_USER_EMAIL,
      date: lastUpdatedToIsoDate(cfg.details.lastUpdated),
      objectId,
      objectName: row?.name ?? cfg.headerTitle,
      dateStart: cfg.details.dateOfStart,
      dateEnd: cfg.details.dateEnd,
      fulfillmentPercent: formatFulfillmentPercent(cfg.details.currentFulfillment),
      contractor: cfg.details.contractor,
      sviObjectId: objectId,
    },
  };
}

export function getSviObjectMapEvents(): IEvent[] {
  const events = Object.values(objectConfigs)
    .filter((cfg) => cfg.hasDashboard)
    .map((cfg) => buildSviObjectMapEvent(cfg.objectId))
    .filter((event): event is IEvent => event != null);

  return spreadSviObjectMapEventCoordinates(events);
}

export function findSviObjectMapEventByEventId(eventId: string): IEvent | null {
  const objectId = parseSviObjectEventId(eventId);
  if (!objectId) {
    return null;
  }

  const spreadEvents = getSviObjectMapEvents();
  const found = spreadEvents.find(
    (event) =>
      event.properties.id === eventId ||
      event.properties.sviObjectId === objectId,
  );

  if (!found) {
    return null;
  }

  if (eventId === DREAM_SPECIAL_EVENT_ID) {
    return found;
  }

  return {
    ...found,
    properties: {
      ...found.properties,
      id: eventId,
    },
  };
}

export function normalizeObjectIdParam(raw: string | null | undefined): string | null {
  if (raw == null || raw.trim() === "") return null;
  return raw
    .trim()
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .toUpperCase();
}

/**
 * Resolves a route or query param to an `objectConfigs` key.
 * Padded IDs (e.g. `"0003"`) and short numeric IDs (e.g. `"3"`) both map to `"0003"`.
 */
export function canonicalObjectConfigKey(
  raw: string | null | undefined,
): string | null {
  const id = normalizeObjectIdParam(raw);
  if (!id) return null;
  if (objectConfigs[id]) return id;
  if (/^\d+$/.test(id)) {
    const padded = id.padStart(4, "0");
    if (objectConfigs[padded]) return padded;
  }
  return null;
}

/** Unpadded object index for S3 path `Object<N>` (e.g. `"0003"` → `"3"`). */
export function toS3ObjectNumber(objectId: string): string {
  const stripped = objectId.replace(/^0+/, "") || objectId;
  return stripped;
}

export function toS3ObjectFolder(objectId: string): string {
  return `Object${toS3ObjectNumber(objectId)}`;
}

/** Dashboard object when URL has no valid `fromObjectStats`. */
export const DEFAULT_SVI_DASHBOARD_OBJECT_ID = "0001";

export function resolveDashboardObjectId(fromObjectStats: string | null | undefined): string {
  const key = canonicalObjectConfigKey(fromObjectStats);
  if (key && objectConfigs[key]?.hasDashboard) {
    return key;
  }
  return DEFAULT_SVI_DASHBOARD_OBJECT_ID;
}

/** Same rule as `resolveDashboardObjectId`: object id maps to a config with `hasDashboard`. */
export function objectIdHasDashboard(raw: string | null | undefined): boolean {
  const key = canonicalObjectConfigKey(raw);
  return Boolean(key && objectConfigs[key]?.hasDashboard);
}

export function getDashboardQuartersForYear(
  objectId: string,
  year: number,
): IObjectQuarterData[] {
  const cfg = objectConfigs[objectId] ?? objectConfigs[DEFAULT_SVI_DASHBOARD_OBJECT_ID];
  const list = cfg.quartersByYear[year as DashboardYearKey];
  if (list && list.length > 0) {
    return list;
  }
  // Legacy: year 2026 was not in the table; UI still used 2025 quarter data.
  if (year === 2026) {
    const y2025 = cfg.quartersByYear[2025];
    if (y2025 && y2025.length > 0) {
      return y2025;
    }
  }
  return BLANK_YEAR_QUARTERS;
}
